export const DRAWERS_TOGGLE_DRAWER = 'DRAWERS_TOGGLE_DRAWER';
export const DRAWERS_RESET_STATE = 'DRAWERS_RESET_STATE';

export function toggleDrawer(drawerName) {
  return {
    type: DRAWERS_TOGGLE_DRAWER,
    drawerName,
  };
}

export function resetDrawersState() {
  return {
    type: DRAWERS_RESET_STATE,
  };
}
